
/**
 * Skeleton Loader Component
 * Shimmer effect for loading states
 */
export function Skeleton({ className = '', variant = 'rectangular' }) {
  const variantClasses = {
    rectangular: 'squircle-sm',
    circular: 'rounded-full',
    text: 'rounded',
  };

  return (
    <div
      className={`shimmer bg-gray-200 dark:bg-elevated-dark-2 ${variantClasses[variant]} ${className}`}
      style={{ minHeight: variant === 'text' ? '1rem' : undefined }}
    />
  );
}

export function DesignCardSkeleton() {
  return (
    <div className="bg-white dark:bg-elevated-dark-2 squircle p-4 shadow-soft">
      {/* Thumbnail */}
      <Skeleton className="w-full aspect-[4/3] mb-4" />
      
      {/* Title */}
      <Skeleton variant="text" className="w-3/4 h-5 mb-2" />
      
      {/* Subtitle */}
      <Skeleton variant="text" className="w-1/2 h-4 mb-4" />
      
      {/* Button */}
      <Skeleton className="w-full h-10" />
    </div>
  );
}

export function PlaylistTileSkeleton({ layout = 'tile' }) {
  if (layout === 'row') {
    return (
      <div className="flex items-center gap-3 px-2 py-2.5">
        <Skeleton className="w-[96px] h-[54px] flex-shrink-0" />
        <div className="flex-1">
          <Skeleton variant="text" className="w-3/4 h-4 mb-2" />
          <Skeleton variant="text" className="w-1/3 h-3" />
        </div>
      </div>
    );
  }
  return (
    <div className="w-[128px] xl:w-[152px] flex-shrink-0 p-1.5 squircle-sm bg-white dark:bg-elevated-dark-2 border border-gray-200 dark:border-white/5">
      <Skeleton className="w-full aspect-video mb-2" />
      <Skeleton variant="text" className="w-5/6 h-3.5 mb-1.5" />
      <Skeleton variant="text" className="w-1/2 h-3" />
    </div>
  );
}

export function AgentCardSkeleton() {
  return (
    <div className="bg-white dark:bg-elevated-dark-2 squircle p-6 shadow-soft">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <Skeleton variant="text" className="w-2/3 h-5 mb-2" />
          <Skeleton variant="text" className="w-1/2 h-4" />
        </div>
        <Skeleton variant="circular" className="w-16 h-6" />
      </div>
      
      <Skeleton variant="text" className="w-full h-4 mb-2" />
      <Skeleton variant="text" className="w-3/4 h-4 mb-4" />
      
      <Skeleton className="w-full h-9" />
    </div>
  );
}

export default Skeleton;
